import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from '../../resources';
import { getClientPortalConfiguration } from '../../../services/config';
import { IPortalConfig } from '../../../services/config/types';

export const ThunkGetPortalConfig = createAsyncThunk<IPortalConfig>(
  `${storeResources.CONFIG}/getPortalConfig`,
  () => getClientPortalConfiguration().then(res => res.data),
);

export default ThunkGetPortalConfig;
